module.exports = __webpack_public_path__ + "img/new-user.3630475e.png";